import Grid2 from '@mui/material/Grid';

import InventoryCards from '../InventoryCards/InventoryCards';
import useStats from './useStats';

interface StatsProps {
  activeSkuCount: number | null;
}

const Stats = ({ activeSkuCount }: StatsProps) => {
  const hook = useStats({ activeSkuCount });
  return (
    <Grid2 container spacing={1} rowGap={4} justifyContent="center" alignItems="center">
      {hook.stats.map((data, index) => (
        <Grid2 size={{ xxs: 12, xs: 6, lg: 3, xl: 2, xxl: 1.5 }} key={index}>
          <InventoryCards {...data} />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default Stats;
